// extracted by mini-css-extract-plugin
export var button = "Button-module--button--3boGY";
export var button__label = "Button-module--button__label--1MLzp";
export var button__hover = "Button-module--button__hover--35Y6C";
export var buttonSpinner = "Button-module--button--spinner--2F-s0";
export var buttonDisabled = "Button-module--button--disabled--58g-r";